function parseRichText(richText: string) {
  return { __html: richText };
}

export const UtilityService = {
  parseRichText,
};
